import cloneDeep from 'lodash/cloneDeep';
import widgetHelper from '../widget-utilities/widget-helper';

/* Config builder for list */
var listConfigBuilder = function listConfigBuilder() {

    // Remove unwanted properties, add custom properties and initialize null/ undefined values
    var configBuilder = function configBuilder(config) {

        // Modify common widget config properties
        config = widgetHelper.modifyWidgetConfigProperties(cloneDeep(config));

        return config;
    };

    return {
        configBuilder: configBuilder
    };
};
export default listConfigBuilder();